<template>
  <div>
    <div>
      <div class="mb-6">
        <v-btn text :to="{ name: 'Produits', query: { ...$route.query } }"
          ><v-icon>mdi-arrow-left</v-icon> {{ $t("boutique.retourALaListeDesProduits") }}</v-btn
        >
      </div>
      <Produit :id="id" />
    </div>
  </div>
</template>

<script>
import Produit from "@/components/boutique/Produit"
export default {
  components: {
    Produit
  },
  props: {
    id: String
  }
}
</script>

<style scoped>
</style>